// eslint-disable-next-line import/named
import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

const HEARTBEAT_MS = 5000;
const HEALTH_CHECK_URL = `${environment.BASE_API_URL}`;

@Injectable({ providedIn: 'root' })
export class BackendHealthService implements OnDestroy {
  private readonly _isBackendDown$ = new BehaviorSubject<boolean>(false);
  readonly isBackendDown$ = this._isBackendDown$.asObservable();
  private heartbeatId: ReturnType<typeof setInterval> | null = null;

  reportUnhealthy(): void {
    if (!this._isBackendDown$.value) {
      this._isBackendDown$.next(true);
    }
    this.ensureHeartbeat();
  }

  reportHealthy(): void {
    if (this._isBackendDown$.value) {
      this._isBackendDown$.next(false);
    }
  }

  private ensureHeartbeat(): void {
    if (this.heartbeatId) return;
    this.heartbeatId = setInterval(() => this.ping(), HEARTBEAT_MS);
  }

  private async ping(): Promise<void> {
    try {
      await fetch(HEALTH_CHECK_URL, { mode: 'no-cors', cache: 'no-store' });
      this.reportHealthy();
      this.stopHeartbeat();
    } catch {
      // still unreachable
    }
  }

  private stopHeartbeat(): void {
    if (this.heartbeatId) {
      clearInterval(this.heartbeatId);
      this.heartbeatId = null;
    }
  }

  ngOnDestroy(): void {
    this.stopHeartbeat();
  }
}
